import React from 'react';

import { SelectItem, Stack, Text } from '@eluve/components';

export interface PromptTemplateSelectItemProps {
  templateId: string;
  templateName: string;
  templateDescription: string | null;
  icon?: React.ReactNode;
}

export const PromptTemplateSelectItem: React.FC<
  PromptTemplateSelectItemProps
> = ({ templateId, templateName, templateDescription, icon }) => {
  const optionContent = (
    <div className="max-w-96 py-1">
      <Text>{templateName}</Text>
      <Text weight="regular" className="sm:text-sm">
        {templateDescription}
      </Text>
    </div>
  );

  return (
    <SelectItem
      key={templateId}
      className="focus:bg-bg-accent-quaternary"
      value={templateId ?? ''}
    >
      {icon ? (
        <Stack direction="horizontal" align="center" gap={2} fullWidth={false}>
          {icon}
          {optionContent}
        </Stack>
      ) : (
        optionContent
      )}
    </SelectItem>
  );
};
